import {connect} from "react-redux";
import Tagged from "./Tagged";
import {bindActionCreators} from "redux";
import {taggedAlongRejectOrApproval, taggedAlongById} from "../../service/Dealer/action";
import {viewActivity} from "../../service/Activity/action";

const mapStateToProps = (state) => ({
    taggedApproveAndReject:state.Dealer.taggedApproveAndReject,
    taggedById:state.Dealer.taggedById,
    activityByIdDetails:state.Activity.activityByIdDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            taggedAlongRejectOrApproval,
            viewActivity,
            taggedAlongById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Tagged);
